module.exports = __webpack_public_path__ + "img/KarimKaka-MachiYakan.2d830469.jpg";